module.exports = __webpack_public_path__ + "static/media/child-sponsorship.1b5600fc.PNG";